import React, {useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import Variables from '../global'
import Vector from '../Vector'

function ItemCard ({ item }) {

  return (
    <React.Fragment>
      <div className='col-12 col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4 item-container'>
        <div className='item-card'>
          <Link className='item-card-link' to={`/item/${item.id}`}>
            <div className='item-image'>
              <img
                src={`${Variables.base_url}/api/images/thumbnail-md/${item.image}`}
              />
            </div>
            
            <div className='item-name'>{item?.itemName?.length > 80 ? item.itemName.substring(0,80).concat("...").toLowerCase():item.itemName.toLowerCase()}</div>
            <div className='item-stars'>
              {Array.from({length: 5},(_,index) => <Vector key={index} style={{margin:'0 2px',width:'10px'}} icon={'star'} fill={'black'} />)}
            </div>
            <div className='item-price'>From $ {item.minPrice}</div>
          </Link>
          
          
        </div>
      </div>
    </React.Fragment>
  )
}

export default ItemCard
